
export function MenuInner() {
  return (
    <>
      {/* <MenuItem title='Inicio' to='/dashboard' /> */}
    </>
  )
}
